import React from "react";
import classes from "./Hero.module.css";
import AnimatedTextCharacter from "../../AnimatedTextCharacter";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ServiceCard from "./ServiceCard";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import ServicesSlider from "./ServicesSlider";
import { useTranslation } from "react-i18next";

function Hero() {
  const { t } = useTranslation();
  const SERVICES_DATA = t("services", { returnObjects: true });

  return (
    <div className={classes.hero} id="homeSection">
      <div className={classes.heroContent}>
        <h2>
          {/* What keeps you up at night? */}
          <AnimatedTextCharacter text={`${t("Hero.text1")}`} isVisible={true} />
        </h2>
        <p>{t("Hero.text2")}</p>
        <h4>
          {t("Hero.text3")}
          <ArrowForwardIcon />
        </h4>
      </div>
      {/* <h1>
        Speech and Language Therapy - <span>reimagined</span>
      </h1>
      <p>engaging, cost-effective, flexible, data-driven.</p>
      <button onClick="" className={classes["learn-more-btn"]}>
        Learn more
      </button> */}
      {/* <img className='logo' src={require("../../assets/logo.png")} alt='logo' /> */}
      <div className={classes.servicesCardsDiv}>
        {SERVICES_DATA.map((service) => (
          <ServiceCard icon={service.icon} name={service.title} />
        ))}
      </div>

      <div className={classes.responsiveServicesCardsDiv}>
        <ServicesSlider services={SERVICES_DATA} />
      </div>
    </div>
  );
}

export default Hero;
